import { render } from "./PriceConfigsTable.vue?vue&type=template&id=499152cc"
import script from "./PriceConfigsTable.vue?vue&type=script&lang=js"
export * from "./PriceConfigsTable.vue?vue&type=script&lang=js"

import "./PriceConfigsTable.vue?vue&type=style&index=0&id=499152cc&lang=css"

import exportComponent from "/Users/biriukov/Documents/Projects/generate-web-prices/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__